//#region src/async-utils/resolver.ts
var UsedResolverError = class extends Error {
	constructor() {
		super("The resolver was already completed");
	}
};
var Resolver = class {
	resolveCb;
	rejectCb;
	_isCompleted = false;
	promise;
	constructor() {
		this.promise = new Promise((resolverCb, rejectCb) => {
			this.resolveCb = resolverCb;
			this.rejectCb = rejectCb;
		});
	}
	get isCompleted() {
		return this._isCompleted;
	}
	resolve = (value) => {
		if (this._isCompleted) throw new UsedResolverError();
		this._isCompleted = true;
		this.resolveCb(value);
	};
	reject = (error) => {
		if (this._isCompleted) throw new UsedResolverError();
		this._isCompleted = true;
		this.rejectCb(error);
	};
};
//#endregion
export { Resolver, UsedResolverError };
